import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Grid, Button, Card, CardHeader, CardContent, Typography} from '@material-ui/core';
import {createForm, formShape} from 'rc-form';
import {FormErrors} from 'components/common';
import {InputField} from 'components/common/fields';
import {isEmpty} from 'lodash/lang';
import {login} from 'actions/account';
import {formatErrors} from 'actions/errors';
import {PrimaryButton} from '../common/StyledButtons';
import {Link} from 'react-router-dom';


class Login extends React.Component {
    static propTypes = {
        form: formShape.isRequired,
        login: PropTypes.func.isRequired,
        formatErrors: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            errors: {},
            submitting: false,
        };
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    handleFormSubmit(e) {
        e.preventDefault();
        const {form: {validateFields}} = this.props;
        const {login, formatErrors} = this.props;
        const {router} = this.context;
        validateFields((error, value) => {
            if (isEmpty(error)) {
                this.setState({submitting: true});
                login(value)
                    .then(() => {
                        router.history.push('/');
                    })
                    .catch(err => formatErrors(err).then(err => {
                        this.setState({
                            errors: err,
                            submitting: false,
                        });
                    }));
            }
        });
    }

    render() {
        const {errors, submitting} = this.state;
        const {form} = this.props;
        return (
            <div className="authentication login">
                <Card>
                    <CardHeader
                        title={<Typography color="primary" className="authentication-title">Quizscape</Typography>}/>
                    <CardContent>
                        <FormErrors errors={errors}/>
                        <Grid container component="form" onSubmit={this.handleFormSubmit}>
                            <Grid item xs={12}>
                                <InputField
                                    name="email"
                                    label="Email"
                                    variant="outlined"
                                    margin="dense"
                                    rules={[
                                        {required: true, message: 'Please enter an email'},
                                    ]}
                                    form={form}
                                    initialValue=""
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <InputField
                                    name="password"
                                    label="Password"
                                    type="password"
                                    variant="outlined"
                                    margin="dense"
                                    rules={[
                                        {required: true, message: 'Please enter password'},
                                    ]}
                                    form={form}
                                    initialValue=""
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <PrimaryButton type="submit" fullWidth
                                    disabled={submitting}>
                                    Login
                                </PrimaryButton>
                            </Grid>
                            <Grid item xs={12}>
                                <Link to={'/reset'}>
                                    Forgot Password?
                                </Link>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </div>
        );
    }
}

Login.contextTypes = {
    router: PropTypes.object.isRequired
};

const mapDispatchToProps = (dispatch) => ({
    formatErrors: (...args) => dispatch(formatErrors(...args)),
    login: (...args) => dispatch(login(...args)),
});

export default connect(
    null,
    mapDispatchToProps
)(createForm()(Login));
